import SummaryTable from "models/backoffice/modelComponents/SummaryTable";

import Slide from "models/backoffice/slideDesign/Slide";
import SlideTitle from "models/backoffice/slideDesign/SlideTitle";
import { forwardRef } from "react";

const FundSummarySlide = forwardRef(
  ({ vizInfo, scaleActive, configurationLinks }, ref) => {
    return (
      <Slide slideWidth={1000} scaleActive={scaleActive} loading={!vizInfo}>
        <SlideTitle size={2}></SlideTitle>
        <SummaryTable ref={ref} vizInfo={vizInfo} />
      </Slide>
    );
  },
);

export default FundSummarySlide;
